import { Divider, Typography } from "@material-ui/core";
import React, { Component } from "react";
import { withRouter } from 'react-router-dom';
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { getDecks, updateHeaderInfo, copyDeck, getUserDetails } from "../actions";
import { DeckCard, CopyrightWidget, LoadingCard } from "../components";
import IconButton from "@material-ui/core/IconButton";
import AddIcon from '@material-ui/icons/Add';
import Modal from '@material-ui/core/Modal';
import { deviceData, setContainer, getThisYear, setActiveNavigationWidget } from "../common";
import { isBrowser, isElectron } from 'react-device-detect';

class DeckListScreen extends Component {
    state = {
        reload: false,
        copyModal: false,
        text: 'test...',
        loading: true,
        deckList: null
    }

    componentDidMount = async () => {
        await this.props.updateHeaderInfo({
            route:"/createDeckScreen", 
            name: "Custom Decks", 
            iconTwo: 'menu',
            iconOne: 'home',
        });

        setActiveNavigationWidget("myDecksFooterIcon");

        await document.getElementById('root').scrollTo({top: 0, behavior: "smooth"});
        const { mcid, key } = this.props.auth_feedback;
        var tracking = deviceData(this.props.location, 'navigate')
        tracking.action = 'navigate';

        // await this.props.getUserDetails( mcid, key, tracking );

        return this.props.getDecks({ mcid: mcid, key: key, tracking: tracking }); 
    };

    componentDidUpdate = async (prevProps, prevState) => {
        if (
            prevProps.deckList !== this.props.deckList &&
            this.state.deckList === null
        ) {
            this.setState({ ...this.state, deckList: this.props.deckList })
        } else if (prevState.deckList !== this.state.deckList) {
            setTimeout(() => {
                this.setState({ ...this.state, deckList: this.props.deckList, loading: false}) 
            }, 150)
        }
        
        if (this.state.reload) {
            this.setState({ ...this.state, reload: false});
        }
    }

    handleOpen = () => {
        this.setState({
            ...this.state,
            copyModal: true,
        });
    };

    handleClose = () => {
        this.setState({
            ...this.state,
            copyModal: false,
        });
    };

    copyThisDeck = async (id) => {
        let data = {
            mcid: this.props.user_details.mcid,
            key: this.props.user_details.key,
            deckID: id
        }
        let obj = this.state.deckList.find(item => item.deckID == Number(id));

        await this.setState({ ...this.state, loading: true});

        await this.props.copyDeck(data);

        setTimeout(() => {
            return this.props.getDecks({ 
                mcid: this.props.user_details.mcid, 
                key: this.props.user_details.key 
            });
        }, 250)
        
        // this.handleOpen();
    }

    setColorObj = (type = 'base') => {
        let r;

        switch (type) {
            default: {
                r = {
                    deck: "neutralGreenCard",
                    text: "neutralGreenText",
                    button: "neutralGreenCard"
                }
            }
        }
        return r;
    }

    mapMyDeckCards = () => {
        const deckList = this.state.deckList;

        if (typeof deckList !== 'undefined' && deckList.length > 0) {            
            return deckList.map((deck, index) => {
                let percomp = Math.trunc((Number(deck.totaAnswered) / Number(deck.totalQuestions)) * 100);
                if (percomp > 100) { percomp = 100; }
                let colorObj = (typeof deck.deckColor !== 'undefined' ? this.setColorObj(deck.deckColor) : this.setColorObj());

                return (
                    <DeckCard
                        deckColor={colorObj.deck} 
                        textColor={colorObj.text}
                        buttonColor={colorObj.button}
                        index={index}
                        deckName={deck.deckname}
                        deckID={deck.deckID}
                        value={deck.totalQuestions}
                        gameMode={deck.gameMode}
                        deck={deck}
                        complete={percomp}
                        titleClass="deck-card-title"
                        copyDeck={() => this.copyThisDeck(deck.deckID)}
                        owner={Number(deck.owner)}
                        isWrong={deck.isWrong}
                        totalQuestions={deck.totalQuestions}
                        flashcard={deck.flashCards} 
                    />
                );
            });
        } else {
            return (
                <main style={{ "minHeight": "44vh" }}>
                    <article className="margin-bottom-8 width100">
                        <p>You currently have no decks.</p>
                        <p>Click the link below to create your first deck and begin studying.</p>
                    </article>
                                        
                    <aside className="margin-top-16 margin-bottom-16">
                        <Link
                            to={{
                                pathname: "/createDeckScreen"
                            }}
                            className="sasp-submit-btn"
                        >
                            Create Deck Now
                        </Link>
                    </aside>
                </main>
            );
        }
    };

    setContainer = (bool) => {
        if (bool) {
            if (isBrowser && !isElectron) {
                return { padding: "16px 16px 32px", margin: "0 0 64px", width: "calc(100% - 40px)", height: "calc(100vh - 160px)" };
            } else {
                return { padding: "16px 16px 32px", margin: "0 0 64px", width: "calc(100% - 32px)", height: "calc(100vh - 160px)" };
            }
            
        } else {
            if (isBrowser && !isElectron) {
                return { padding: "16px", margin: "0 0 64px", width: "calc(100% - 40px)", height: "calc(100vh - 160px)" };
            } else {
                return { padding: "16px", margin: "0 0 64px", width: "calc(100% - 32px)", height: "calc(100vh - 160px)" };
            }
        }
    }

    render() {
        if (!this.state.loading) {
            return (
                <>
                    {/* <div style={{margin: "0 0 32px"}} className="heigth100 aua-overflow"> */}
                    <div style={setContainer(isBrowser)} className=" aua-overflow">
                        <div style={{ padding: "0 0 16px"}}>
                            <Typography className="homeDividerText">
                                My Decks
                                <div style={{display:"flex", flexDirection:"row", justifyContent:"flex-end", alignItems:"center", float: "right"}}>
                                    <Link
                                        to={{
                                            pathname: "/createDeckScreen"
                                        }}
                                    >
                                        <IconButton className="titleIcon" aria-label="create-deck">
                                            <AddIcon className="text-white" style={{ fontSize: "0.8em" }}/>
                                        </IconButton>
                                    </Link>
                                </div>
                            </Typography>
                            
                            <Divider className="SASPTestsDivider" style={{width: "100%", margin: "0"}}/>
                        </div>

                        <div className="deck-container" style={{ margin:"8px 0 16px", width: "calc(100%)" }}>
                            {this.mapMyDeckCards(this.props)}
                        </div>

                        <CopyrightWidget 
                            year={getThisYear()}
                            textAlign={'center'}
                            className="margin-top-8 padding-top-8 padding-bottom-24 padding-left-16 padding-right-16"
                        />
                    </div>

                    <Modal
                        open={this.state.copyModal}
                        onClose={this.handleClose}
                        aria-labelledby="copyModal-modal-title"
                        aria-describedby="copyModal-modal-description"
                        style={{
                            display:"flex",
                            flexDirection:"column",
                            justifyContent:"center",
                            alignItems:"center"
                        }}
                    >
                        <div 
                            style={{
                                position: 'absolute',
                                backgroundColor: "#fff",
                                border: "2px solid #00567a",
                                borderRadius: "8px",
                                padding: "32px 16px",
                                maxHeight: `68vh`,
                                width: '75vw',
                                overflow: 'auto',
                                outline: "none"
                            }}
                        >
                            <div 
                                id="copyModal-modal-description" 
                                style={{fontSize: "1rem"}}
                            >
                                <div>
                                    <p>You have copied <span className="text-blue">{this.state.text}</span>.</p>
                                    <p>You can find the deck on your decks page.</p>
                                </div>
                            </div>
                        </div>
                    </Modal>
                </>
            );
        } else {
            return <LoadingCard texting="Loading Decks" />
        }
    }
}

const mapStateToProps = state => {
    const { auth_feedback, user_details } = state.auth;
    const { headerText, iconOne, iconTwo, backgroundcolor } = state.style;
    const { deckList } = state.decks;
    return {
        headerText,
        iconOne,
        iconTwo,
        backgroundcolor,
        deckList,
        auth_feedback,
        user_details
    };
};

export default connect(mapStateToProps, 
    { 
        updateHeaderInfo, getDecks, copyDeck, getUserDetails
    })(withRouter(DeckListScreen));